import { ManualContext } from '@f_qwep/context/Manual_context';
import React, { useContext, useEffect, useState } from 'react';
import GeneralJoyride from '../GeneralJoyride';
import { IconMaskot } from '@f_components/icons/IconMascot';

export function LicensesManual() {
    const { setChooseManual } = useContext(ManualContext);

    const [run, setRun] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [steps, setSteps] = useState<any>([
        {
            target: '#workPeriod',
            content: (
                <div>
                    <IconMaskot />
                    <p>Нажмите, чтобы узнать свой тариф</p>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        //   {
        //     target: '#chooseTariff',
        //     content: 'Нажмите, чтобы ознакомиться с тарифами',
        //     disableBeacon: true,
        //     hideFooter: true,
        //     spotlightClicks: true,
        //   },
    ]);

    useEffect(() => {
        if (window.location.pathname == '/app-qwep/' || window.location.pathname == '/app-qwep') {
            setRun(true);
            setCurrentStep(0);
        }
    }, []);

    const handleJoyrideCallback = (data: any) => {
        const { action, step, index, status, type } = data;

        if (type === 'step:after' && action === 'next' && !step.hideFooter) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else if (type === 'step:before') {
        } else if (
            type === 'step:after' &&
            (action === 'skip' || action === 'close' || action === 'last' || action === 'skip')
        ) {
            setCurrentStep(0);
            setRun(false);
            setChooseManual();
        }
    };

    return (
        <div>
            <GeneralJoyride steps={steps} run={run} callback={handleJoyrideCallback} stepIndex={currentStep} />
        </div>
    );
}
